/**
 * RESPONSIBILITY: draw the way through to an event that has its own site.
 *
 * The requirements are explicit that the largest events — a conference, a convention —
 * get a site of their own and a link from here. This band is that link, made to look
 * like a destination rather than a footnote, so the page does not pretend to hold
 * content it has deliberately given away.
 */
import { Html } from '@framework/react';
import { THEME } from '@app/sections';
import { Band } from './Band';
import { Picture } from '../../commons/Picture';
import type { BandProps } from './kind';

export function Elsewhere({ s }: BandProps) {
  if (!s.ctaHref && !s.heading) return null;

  return (
    <Band theme={THEME.Elsewhere} heading={s.heading}>
      <div className="ev-elsewhere">
        <Picture value={s.image} alt="" className="ev-elsewhere-pic" />
        <div className="ev-elsewhere-words">
          {s.bodyHtml ? <Html className="md-body ev-prose">{s.bodyHtml}</Html> : null}
          {s.ctaLabel ? <a className="btn" href={s.ctaHref || '#'}>{s.ctaLabel}</a> : null}
        </div>
      </div>
    </Band>
  );
}
